/* s1-pdp — "Buy box v2 refresh": (1) open the 4-per-row size scroller on the
   first in-stock size (XS is usually sold out); (2) gallery videos all
   chrome-free like the hero slide. Re-runs after load / resize and on DOM
   changes (the section re-renders on fit switches). Loaded by
   sections/s1-pdp.liquid when the v2_refresh setting is on. */
(function(){
  function start(row){
    if(!row||row.dataset.s1Started||row.scrollWidth<=row.clientWidth)return;
    var first=[].slice.call(row.children).find(function(p){return !p.classList.contains('is-soldout')&&!p.hasAttribute('data-s1-notify-me');});
    if(first){row.scrollLeft=first.offsetLeft-row.children[0].offsetLeft;row.dataset.s1Started='1';}
  }
  function all(){document.querySelectorAll('.s1-pdp--v2r [data-s1-size-scroll]').forEach(start);stripControls();}
  /* the kit gives only the first slide's video the chrome-free "hero"
     treatment; every other gallery video renders with native controls, so a
     colour whose chunk starts on a video shows a control bar. Under the
     refresh all gallery videos behave like the hero: no controls, muted
     loop, tap opens the fullscreen viewer. */
  function stripControls(){
    document.querySelectorAll('.s1-pdp--v2r video.s1-pdp__gallery-media[controls]').forEach(function(v){
      v.removeAttribute('controls');
      v.muted = true; v.loop = true; v.playsInline = true;
    });
  }
  all();window.addEventListener('load',all);requestAnimationFrame(all);setTimeout(all,300);setTimeout(all,1200);
  window.addEventListener('resize',function(){document.querySelectorAll('.s1-pdp--v2r [data-s1-size-scroll]').forEach(function(r){if(r.scrollLeft===0)delete r.dataset.s1Started;});all();});
  new MutationObserver(all).observe(document.body,{childList:true,subtree:true});
})();
